import { SurveyNavigationButton } from 'survey-react-ui';
import { Context } from 'react';

import { Button } from '../../Button/Button';
import { SurveyContext, SurveyContextProps } from '../Survey.context';

export class SurveyNavButton extends SurveyNavigationButton {
  static contextType: Context<SurveyContextProps> = SurveyContext;
  context!: React.ContextType<typeof SurveyContext>;

  protected renderElement(): JSX.Element {
    return (
      <Button
        type="button"
        disabled={this.item.disabled}
        onClick={this.item.action}
        loading={this.context.completing}
      >
        {this.item.title}
      </Button>
    );
  }
}
